/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {RegisterOrderRequestCart} from './RegisterOrderRequestCart';
import {User} from './User';

/**
 * The RegisterOrderRequest model module.
 * @module model/RegisterOrderRequest
 * @version v1
 */
export class RegisterOrderRequest {
  /**
   * Constructs a new <code>RegisterOrderRequest</code>.
   * @alias module:model/RegisterOrderRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RegisterOrderRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RegisterOrderRequest} obj Optional instance to populate.
   * @return {module:model/RegisterOrderRequest} The populated <code>RegisterOrderRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RegisterOrderRequest();
      if (data.hasOwnProperty('cart'))
        obj.cart = RegisterOrderRequestCart.constructFromObject(data['cart']);
      if (data.hasOwnProperty('user'))
        obj.user = User.constructFromObject(data['user']);
    }
    return obj;
  }
}

/**
 * @member {module:model/RegisterOrderRequestCart} cart
 */
RegisterOrderRequest.prototype.cart = undefined;

/**
 * @member {module:model/User} user
 */
RegisterOrderRequest.prototype.user = undefined;

